import React from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Contactanos from "./pages/Contactanos";
import Nosotros from "./pages/Nosotros";
import InformacionDeInteres from "./pages/InformacionDeInteres";
import ProductosYServicios from "./pages/ProductosYServicios";
import Navbar from "./components/Navbar";
import Factoring from "./pages/Factoring";
import FactoringInternacional from "./pages/FactoringInternacional";
import LibroReclamaciones from "./pages/LibroReclamaciones";

import ScrollToTop from './components/ScrollToTop';
import PoliticaDePrivacidad from "./pages/PoliticaDePrivacidad";

function App() {
  return (
    <Router basename="/">
      <ScrollToTop />
      <div>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/nosotros" element={<Nosotros />} />          
          <Route path="/productosyservicios" element={<ProductosYServicios />} />
          <Route path="/informaciondeinteres" element={<InformacionDeInteres />} />
          <Route path="/contactanos" element={<Contactanos />} />
          <Route path="/factoring" element={<Factoring />} />
          <Route path="/factoringinternacional" element={<FactoringInternacional />} />
          <Route path="/libroreclamaciones" element={<LibroReclamaciones />} />
          
          <Route path="/politicadeprivacidad" element={<PoliticaDePrivacidad/>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
